import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { FormType } from '../../../types/types';
import loginSettingsParams from '../../Login/settingsParams';
import signupSettingsParams from '../../Signup/settingsParams';
import loginStylesParams from '../../Login/stylesParams';
import signupStylesParams from '../../Signup/stylesParams';
import { FormSwitchBarSettings } from './FormSwitchBarSection.types';

interface UseFormSwitchBarSectionSettingsProps {
  formType: FormType;
}

const PARAMS: Record<FormType, FormSwitchBarSettings> = {
  login: loginSettingsParams,
  signup: signupSettingsParams,
};

const STYLE_PARAMS = {
  login: loginStylesParams,
  signup: signupStylesParams,
};

export const useFormSwitchBarSectionSettings = ({
  formType,
}: UseFormSwitchBarSectionSettingsProps) => {
  const settings = useSettings();
  const styles = useStyles();

  if (!(formType in PARAMS)) {
    return {};
  }

  const settingsParams = PARAMS[formType];
  const stylesParams = STYLE_PARAMS[formType];
  const shouldShowFormSwitchBar = styles.get(stylesParams.showFormSwitchBar);
  const prefixText = settings.get(settingsParams.formSwitchBarPrefixText);
  const textButtonText = settings.get(
    settingsParams.formSwitchBarTextButtonText,
  );

  return { shouldShowFormSwitchBar, prefixText, textButtonText };
};
